import { productEntity } from "../domain/entities/product_entity";
import { productIndexEntity } from "../domain/entities/product_index_entity";
import { dropdownProductEntity } from "../domain/entities/dropdown_product_entity";
import http from "../../../plugins/http-common"
import i18n from "../../../i18n";
import { ProductContract } from "../domain/contracts/product_contract";
import { productShowReservedEntity } from "../domain/entities/product_show_reserved_entity";

export const HttpProductRepository = {
	...ProductContract,
	model: productEntity,
	model_index: productIndexEntity,
	model_dropdown: dropdownProductEntity,
	model_show_reserved: productShowReservedEntity,

	async get_products_by_client_id(client_id) {

		const res = await http.get('productsAndKitsByClient/' + client_id);

		const products = [];
		res.data.data.forEach(x => {
			if (x.type == "product") {
				products.push({
					id: "p_" + x.id,
					sku: x.sku,
					type: x.type
				});
			}
			else {
				products.push({
					id: "k_" + x.id,
					sku: x.sku,
					type: x.type
				});
			}
		})

		return products;
	},

	async show(product_id) {
		const res = await http.get('products/show/' + product_id);

		res.data.detailed_stock.forEach(x => {

			x.detail_description = i18n.t('product_details.income') + " " + x.detail_description.split('.')[0] + " - " + x.detail_description.split('.')[1] + " " + i18n.t('product_details.pieces') + " - " + x.detail_description.split('.')[2];

			x.actions = JSON.parse(JSON.stringify([
				{
					name: i18n.t('product_details.adjust'),
					icon: {
						color: 'accent',
						icon: 'tune'
					},
					method: 'showModalEdit',
					permission: "damaged.create"
				},
				{
					name: x.detail_description,
					icon: {
						color: 'accent',
						icon: 'info'
					},
					only_display: true,
					value: true,
					tooltip: 'bottom'
				}

			]));
			x.parameters = x.id;
		})

		return res.data;
	},

	async index(page, per_page, search, sort_by) {
		var sort = ""

		if (sort_by.length > 0) sort = '&sort=' + sort_by[0].field + '&sort_direction=' + sort_by[0].direction;

		const res = await http.get('products?page=' + page + '&per_page=' + per_page + sort + '&search=' + search);
		var result = {
			data: [],
			meta: res.data.meta
		};

		res.data.data.forEach(x => {
			x = x.attributes;

			x.parameters = x.id;
			x.actions = JSON.parse(JSON.stringify([
				{
					name: i18n.t('products.detail_stock'),
					icon: {
						color: 'accent',
						icon: 'list'
					},
					method: 'showProductDetailStock',
					permission: "product.show"
				},
				{
					name: i18n.t('products.details'),
					icon: {
						color: 'accent',
						icon: 'info'
					},
					link: 'products/details/' + x.id,
					permission: "product.show"
				},
				{
					name: i18n.t('products.edit'),
					icon: {
						color: 'accent',
						icon: 'edit'
					},
					link: 'products/edit/' + x.id,
					permission: "product.update"
				},
				{
					name: i18n.t('products.refurbish'),
					icon: {
						color: 'accent',
						icon: 'recycling'
					},
					link: 'products/refurbish/' + x.id,
					permission: "refurbish.index"
				}
			]));

			result.data.push(x);
		})

		return result;
	},

	async get_product_image(product_id) {
		const res = await http.get(`products/${product_id}/image`);

		return res;
	},

	async product_show_reserved(product_id) {
		const res = await http.get(`stocks/reserved/${product_id}`)

		return res;
	}
};